import * as types from "../actionTypes";

export const get = (account_type, pageNumber = null) => {
  return {
    type: types.MANAGER_GET_ACCOUNT_REVIEW_REQUEST,
    account_type: account_type,
    pageNumber
  };
};

export const getSuccess = data => {
  return {
    type: types.MANAGER_GET_ACCOUNT_REVIEW_SUCCESS,
    payLoad: data
  };
};
export const getFailure = error => {
  return {
    type: types.MANAGER_GET_ACCOUNT_REVIEW_FAILURE,
    error: error
  };
};

export const copyToAnotherProject = data => {
  return {
    type: types.MANAGER_COPY_TRANSACTIONS_TO_OTHER_PROJECT_REQUEST,
    data
  };
};

export const copyToAnotherProjectSuccess = data => {
  return {
    type: types.MANAGER_COPY_TRANSACTIONS_TO_OTHER_PROJECT_SUCCESS,
    payLoad: data
  };
};
export const copyToAnotherProjectFailure = () => {
  return {
    type: types.MANAGER_COPY_TRANSACTIONS_TO_OTHER_PROJECT_FAILURE
  };
};
